import { useQuery } from "@tanstack/react-query";
import identity from "lodash/identity";

import type { Keyword } from "./types";
import { KEYWORD_LIST_SUGGESTION_PATHNAME, fetchKeywords } from "./utils/fetchKeywords";

interface UseKeywordListSuggestionsProps {
    seedKeyword: string | undefined;
    countryId: number;
    enabled: boolean;
    select?: (data: { keywords: Keyword[] }) => Keyword[] | undefined;
}

export const useKeywordListSuggestions = ({
    seedKeyword,
    countryId,
    enabled,
    select = identity,
}: UseKeywordListSuggestionsProps) => {
    return useQuery({
        queryKey: [KEYWORD_LIST_SUGGESTION_PATHNAME, seedKeyword, countryId],
        queryFn: async () => {
            if (seedKeyword !== undefined) {
                return fetchKeywords(countryId, seedKeyword);
            }
            return { keywords: [] };
        },
        enabled,
        select,
    });
};
